import ArmorManagePane from './ArmorManagePane';

export default ArmorManagePane;
export { ArmorManagePane };
